<div class="container mx-auto p-6">
  <h2 class="text-3xl font-semibold text-center mb-6">Especialistas</h2>
  <div class="flex justify-between items-center mb-4">
    <button
      (click)="goBack()"
      class="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded"
    >
      Volver
    </button>
    <button
      class="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded"
      (click)="goToCreateSpecialist()"
    >
      Crear Especialista
    </button>
  </div>
  <div class="flex justify-between items-center mb-4">
    <select
      class="border border-gray-300 rounded py-2 px-4 w-1/3"
      [(ngModel)]="selectedRole"
      (change)="onRoleChange()"
    >
      <option value="2">Especialista en Documentación</option>
      <option value="3">Especialista en Evaluaciones</option>
    </select>
    <input
      type="text"
      class="border border-gray-300 rounded py-2 px-4 w-1/3"
      placeholder="Buscar por especialista..."
      [(ngModel)]="searchText"
      (input)="applyFilter()"
    />
  </div>

  <div class="overflow-x-auto">
    <table class="min-w-full border-collapse border border-gray-200">
      <thead>
        <tr class="bg-gray-100 text-left">
          <!-- <th class="py-2 px-4 border-b border-gray-200">ID</th> -->
          <th class="py-2 px-4 border-b border-gray-200">DNI</th>
          <th class="py-2 px-4 border-b border-gray-200">Apellidos y Nombres</th>
          <th class="py-2 px-4 border-b border-gray-200">Correo</th>
          <!-- <th class="py-2 px-4 border-b border-gray-200">Fecha Asignación</th> -->
          <th class="py-2 px-4 border-b border-gray-200">Estado</th>
          <th class="py-2 px-4 border-b border-gray-200">Acciones</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let specialist of getPaginatedSpecialists()"
          class="hover:bg-gray-50 transition"
        >
          <!-- <td class="py-2 px-4 border-b border-gray-200">
            {{ specialist.id_rol_usuario }}
          </td> -->
          <td class="py-2 px-4 border-b border-gray-200">{{ specialist.usuario.codigo_documento }}</td>
          <td class="py-2 px-4 border-b border-gray-200">
            {{ specialist.usuario.nombres | uppercase }} {{ specialist.usuario.apellidos | uppercase }}
          </td>
          <td class="py-2 px-4 border-b border-gray-200">
            {{ specialist.usuario.correo }}
          </td>
          <!-- <td class="py-2 px-4 border-b border-gray-200">
            {{ specialist.fecha_asignacion | date : "dd/MM/yyyy" }}
          </td> -->
          <td class="py-2 px-4 border-b border-gray-200">
            <span
              [ngClass]="{
                'bg-green-500': specialist.estado == 1,
                'bg-red-500': specialist.estado == 0
              }"
              class="text-white px-3 py-1 rounded-full"
            >
              {{ specialist.estado == 1 ? "Activo" : "Inactivo" }}
            </span>
          </td>
          <td
            class="py-2 px-4 border-b border-gray-200 text-center whitespace-nowrap"
          >
            <button
              class="bg-yellow-500 hover:bg-yellow-600 text-white font-semibold py-1 px-3 rounded"
              (click)="goToSpecialistDetail(specialist)"
              title="Ver Detalles"
            >
              <i class="fas fa-edit"></i>
            </button>
            <button
              class="bg-red-500 hover:bg-red-600 text-white font-semibold py-1 px-3 rounded ml-2"
              (click)="eliminarEspecialista(specialist.id_rol_usuario)"
              title="Eliminar"
              [disabled]="specialist.estado == 0"
              [ngClass]="{
                'opacity-50 cursor-not-allowed': specialist.estado == 0
              }"
            >
              <i class="fas fa-trash"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="flex justify-between items-center mt-6">
    <button
      class="hover:bg-gray-300 border text-gray-800 py-2 px-4 rounded"
      [disabled]="currentPage === 1"
      (click)="changePage(currentPage - 1)"
    >
      Anterior
    </button>
    <span class="text-gray-700">Página {{ currentPage }} de {{ totalPages }}</span>
    <button
      class="hover:bg-gray-300 border text-gray-800 py-2 px-4 rounded"
      [disabled]="currentPage === totalPages"
      (click)="changePage(currentPage + 1)"
    >
      Siguiente
    </button>
  </div>
</div>
